export const organizationMenus = () => ({
    Id: 52,
    id: `main-menu-2-all`,
    path: '/management/organization/organization-management/organizations',
    label: 'Organization',
    Description: 'Organization refers to the art of getting people together on a common platform to make them work towards a common predefined goal. Organization enables the optimum use of resources through meticulous planning and control at the workplace.',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            </g>
        </svg>

    ),
    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Organization Management',
            path: '/management/organization/organization-management/organizations',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm5 7a2 2 0 1 1 0 4h-1v4h1a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4h1v-4H7a2 2 0 1 1 0-4h1V8a5 5 0 1 1 10 0v1h-1zm-4 4v4h-2v-4h2zM8 20a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm10 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1-9h1a1 1 0 1 0 0-2h-1v2zM7 11a1 1 0 1 0 0-2H6v2h1zm5-7a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Organization ',
                    path: '/management/organization/organization-management/organizations',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm5 7a2 2 0 1 1 0 4h-1v4h1a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4h1v-4H7a2 2 0 1 1 0-4h1V8a5 5 0 1 1 10 0v1h-1zm-4 4v4h-2v-4h2zM8 20a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm10 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1-9h1a1 1 0 1 0 0-2h-1v2zM7 11a1 1 0 1 0 0-2H6v2h1zm5-7a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Organization Unit',
                    path: '/management/organization/organization-management/organization-units',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm5 7a2 2 0 1 1 0 4h-1v4h1a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4h1v-4H7a2 2 0 1 1 0-4h1V8a5 5 0 1 1 10 0v1h-1zm-4 4v4h-2v-4h2zM8 20a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm10 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1-9h1a1 1 0 1 0 0-2h-1v2zM7 11a1 1 0 1 0 0-2H6v2h1zm5-7a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Branches',
                    path: '/management/organization/organization-management/branches',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a3 3 0 0 1 3 3v1.1a5.007 5.007 0 0 1 3.9 4.9V12h2a2 2 0 1 1 0 4h-2v2.1a5.007 5.007 0 0 1-3.9 4.9V19a3 3 0 1 1-6 0v-1.1a5.007 5.007 0 0 1-3.9-4.9V14H4a2 2 0 1 1 0-4h2v-1.1a5.007 5.007 0 0 1 3.9-4.9V5a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v1h2V5a1 1 0 0 0-1-1zm-7 8v2h2v-2H5zm10-5v3h-2V7h-2v3h-2V7a3 3 0 0 1 6 0zm5 7v-2h-2v2h2zM7 17a3 3 0 1 0 4 2.83V19h2v.83a3 3 0 1 0 4-2.83v-3.17a5.007 5.007 0 0 0-4 4.9V19h-4v.66a5.007 5.007 0 0 0-4-4.9V17zm7-1h2v-3h-2v3zm-4-3h-2v3h2v-3z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Stores',
                    path: '/management/organization/organization-management/stores',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M2 2h20v5h-1v3a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3h-2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7H2V2zm2 5V4h4v3H4zm6 0V4h4v3h-4zm6-3v3h4V4h-4zm-1 5h2a1 1 0 0 0 1-1V8h-4v1a1 1 0 0 0 1 1zm-8 0h2a1 1 0 0 0 1-1V8H6v1a1 1 0 0 0 1 1zM4 12v6h6v-6H4zm8 0v6h6v-6h-6zm8 6v-6h2v8H2v-8h2v6h16z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Production Plant',
                    path: '/management/organization/organization-management/production-plants',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M2 2h20v5h-1v3a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3h-2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7H2V2zm2 5V4h4v3H4zm6 0V4h4v3h-4zm6-3v3h4V4h-4zm-1 5h2a1 1 0 0 0 1-1V8h-4v1a1 1 0 0 0 1 1zm-8 0h2a1 1 0 0 0 1-1V8H6v1a1 1 0 0 0 1 1zM4 12v6h6v-6H4zm8 0v6h6v-6h-6zm8 6v-6h2v8H2v-8h2v6h16z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Warehouses',
                    path: '/management/organization/organization-management/ware-houses',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2l10 5v13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7l10-5zm0 2.18L4 7.42V20h16V7.42L12 4.18zM6 9h12v3H6V9zm0 5h5v6H6v-6zm7 6v-6h5v6h-5z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Locations',
                    path: '/management/organization/organization-management/locations',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a7 7 0 0 1 7 7c0 2.9-2.72 6.55-7 9.88-4.28-3.33-7-6.98-7-9.88A7 7 0 0 1 12 2zm0 2a5 5 0 0 0-5 5c0 1.9 1.8 4.73 5 7.47 3.2-2.74 5-5.57 5-7.47a5 5 0 0 0-5-5zm0 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
            ]
        },
        {
            id: `coln-1-collections`,
            label: 'IAM',
            path: '/management/organization/iam/pages',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M4 2h10l6 6v14H4V2zm2 2v16h12V9h-5V4H6zm2 4h8v2H8V8zm0 4h8v2H8v-2zm0 4h8v2H8v-2z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Users ',
                    path: '/management/organization/iam/users',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-7 9a5 5 0 0 0-5 5v3h24v-3a5 5 0 0 0-5-5h-2a7 7 0 0 1-14 0H5zm5 5h8a3 3 0 0 1 3 3H5a3 3 0 0 1 3-3h2z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Guests',
                    path: '/management/organization/iam/guests',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-9 9a5 5 0 0 1 5 5v2h14v-2a5 5 0 0 1 5 5h-2a3 3 0 0 0-6 0H4a3 3 0 0 0-6 0H0v-2a5 5 0 0 1 5-5zM7 14a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3H7zm5 0a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0 2a5 5 0 0 1-5 5v2a7 7 0 0 0 14 0v-2a5 5 0 0 1-5-5h-4z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Roles',
                    path: '/management/organization/iam/roles',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-7 9a5 5 0 0 1 5 5v3h2v-3a5 5 0 1 1 10 0v3h2v-3a7 7 0 0 0-14 0v3h2v-3a5 5 0 0 1-5-5zm14 2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM2 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Access Control',
                    path: '/management/organization/iam/access-controls',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM5 8a3 3 0 0 0-3 3v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V11a3 3 0 0 0-3-3H5zm14 2H5a1 1 0 0 1-1-1V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1z" fill="#007BFF"></path>
                                <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'External Authentication',
                    path: '/management/organization/iam/external-authentications',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-7 9a5 5 0 0 1 5 5v3h2v-3a5 5 0 1 1 10 0v3h2v-3a7 7 0 0 0-14 0v3h2v-3a5 5 0 0 1-5-5zm14 2H5a1 1 0 0 1-1-1V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Security',
                    path: '/management/organization/iam/securities',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM5 8a3 3 0 0 0-3 3v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V11a3 3 0 0 0-3-3H5zm14 2H5a1 1 0 0 1-1-1V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Pages',
                    path: '/management/organization/iam/pages',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M4 2h10l6 6v14H4V2zm2 2v16h12V9h-5V4H6zm2 4h8v2H8V8zm0 4h8v2H8v-2zm0 4h8v2H8v-2z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
            ]
        },
        {
            id: `coln-1-collections`,
            label: 'RMS',
            path: '/management/organization/rms/accounts',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M3 2v20h18V2H3zm5 2h8v5H8V4zm0 7h8v5H8v-5zm0 7h8v5H8v-5z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Accounts ',
                    path: '/management/organization/rms/accounts',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 4H6v12h12V6zm-3 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Account Types',
                    path: '/management/organization/rms/account-types',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 4H6v12h12V6zm-3 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Contacts',
                    path: '/management/organization/rms/contacts',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 8a7 7 0 0 1 7 7v4H5v-4a7 7 0 0 1 7-7zm-2 2a5 5 0 0 0-5 5v4h10v-4a5 5 0 0 0-5-5z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
            ]
        },
        {
            id: `coln-1-collections`,
            label: 'Localization Management',
            path: '/management/organization/localization-management/countries',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14zM5 9a7 7 0 0 1 12.565-3.737l2.327-2.326A10.002 10.002 0 0 0 2 12a9.984 9.984 0 0 0 2.911 7.07l2.326-2.327A6.968 6.968 0 0 1 5 9zm7.07 10.089l2.326-2.326A6.968 6.968 0 0 1 19 15a7 7 0 0 1-12.565 3.737l-2.327 2.326A10.002 10.002 0 0 0 22 12a9.984 9.984 0 0 0-2.911-7.07l-2.326 2.327A6.968 6.968 0 0 1 17 15a7 7 0 0 1-4.93 4.089z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Languages ',
                    path: '/management/organization/localization-management/languages',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14zM5 9a7 7 0 0 1 12.565-3.737l2.327-2.326A10.002 10.002 0 0 0 2 12a9.984 9.984 0 0 0 2.911 7.07l2.326-2.327A6.968 6.968 0 0 1 5 9zm7.07 10.089l2.326-2.326A6.968 6.968 0 0 1 19 15a7 7 0 0 1-12.565 3.737l-2.327 2.326A10.002 10.002 0 0 0 22 12a9.984 9.984 0 0 0-2.911-7.07l-2.326 2.327A6.968 6.968 0 0 1 17 15a7 7 0 0 1-4.93 4.089z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Currencies',
                    path: '/management/organization/localization-management/currencies',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM5 9a7 7 0 0 1 7 7v3h2v-3a7 7 0 1 1 14 0v3h2v-3a9 9 0 0 0-9-9H5zm14 4H5a1 1 0 0 1-1-1V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a1 1 0 0 1-1 1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Countries',
                    path: '/management/organization/localization-management/countries',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14zM5 9a7 7 0 0 1 12.565-3.737l2.327-2.326A10.002 10.002 0 0 0 2 12a9.984 9.984 0 0 0 2.911 7.07l2.326-2.327A6.968 6.968 0 0 1 5 9zm7.07 10.089l2.326-2.326A6.968 6.968 0 0 1 19 15a7 7 0 0 1-12.565 3.737l-2.327 2.326A10.002 10.002 0 0 0 22 12a9.984 9.984 0 0 0-2.911-7.07l-2.326 2.327A6.968 6.968 0 0 1 17 15a7 7 0 0 1-4.93 4.089z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
            ]
        },
        {
            id: `coln-1-collections`,
            label: 'Membership Management',
            path: '/management/organization/membership-management/memberships',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Memberships ',
                    path: '/management/organization/membership-management/memberships',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Membership Types',
                    path: '/management/organization/membership-management/membership-types',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Membership Member Mappings',
                    path: '/management/organization/membership-management/membership-member-mappings',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
            ]
        },
        {
            id: `coln-1-collections`,
            label: 'DBN',
            path: '/management/organization/dbn/dbnp',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'DBNP ',
                    path: '/management/organization/dbn/dbnp',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'DBNP Mapping',
                    path: '/management/organization/dbn/dbnp-mappings',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'DBNP Registry',
                    path: '/management/organization/dbn/dbnp-registries',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'OrgRegistry',
                    path: '/management/organization/dbn/org-registries',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
            ]
        },
    ],
}
)
